import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";

function* getGameBundles() {
    try {
        const gameBundles = yield call(() =>
            presetsAPI.getGameBundles()
        );

        yield put({
            type: PresetsActionTypes.GET_BUNDLES_SUCCESS,
            payload: {
                gameBundles: gameBundles.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game bundles list.");

        yield put({
            type: PresetsActionTypes.GET_BUNDLES_FAIL,
            message: e.message
        });
    }
}

export function* getGameBundlesWatcher() {
    yield takeLatest(PresetsActionTypes.GET_BUNDLES, getGameBundles);
}
